module.exports = __webpack_public_path__ + "static/media/logo-crypto-corporate.2e7a88c8.svg";